import { render } from "./BasePlannerAssessor.vue?vue&type=template&id=33c038dc"
import script from "./BasePlannerAssessor.vue?vue&type=script&lang=js"
export * from "./BasePlannerAssessor.vue?vue&type=script&lang=js"

import "./BasePlannerAssessor.vue?vue&type=style&index=0&id=33c038dc&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__